import router from "./router";
import { base_info } from "@/api/user";

// 白名单
const whiteList = [
  "login",
  "Password",
  "WxAuth",
  "AdAudit",
  "Deal",
  "AgreementDetail",
  "AuditAgain"
];

router.beforeEach(async (to, from, next) => {
  // 页面标题
  document.title = to.meta.title;
  const hasToken = localStorage.getItem("myToken");
  // 判断用户是否首次登陆
  if (hasToken) {
    const user = JSON.parse(sessionStorage.getItem("userInfo"));
    // 判断是否有用户信息
    if (user) {
      if (user.role == 16 && to.path == "/") {
        // next("/inspection/inspectionFirst");
        next("/exwarehouse/sweecode")
      } else {
        next();
      }
    } else {
      base_info().then(res => {
        console.log("token是否失效 :>> ", res.result.role);
        // 判断token是否失效,经过请求拦截后,失效将直接跳转登录页
        if (res.code === 0) {
          sessionStorage.setItem("userInfo", JSON.stringify(res.result));
          if (res.result.role == 16 && to.path == "/") {
            // next("/inspection/inspectionFirst");
            next("/exwarehouse/sweecode")
          } else {
            next();
          }
        }
      });
    }
    // 判断token是否失效
  } else {
    // 判断是否进入白名单
    if (whiteList.indexOf(to.name) !== -1) {
      next();
    } else {
      next(`/WxAuth?redirect=${to.path}`);
    }
  }
});
